import React, { useEffect, useState } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { COLORES } from '../../../../config/colores'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { EntityAutocomplete, CerealVariedadDropdown } from '../../../Forms/SharedComponents/containers'

function CamposCargaConRemito (props) {
  const { exportador, planta, handleSubmit, cereal } = props
  const [init, setInit] = useState(false)

  const partial = exportador.split('-')
  const nombreExportador = partial[0]

  useEffect(() => {
    if (cereal && !init) {
      if (document.getElementsByName('netoOrigen')[0]) {
        // si hay cereal inicial y encuentra input de peso neto de origen, hace foco.
        document.getElementsByName('netoOrigen')[0].focus()
      }
      setInit(true)
    }
  }, [cereal, init])

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        width: '100%'
      }}
    >
      <div style={{ width: '95%' }}>
        <Row>
          <Col md={3} >
            <p style={{ borderBottom: '1px solid', padding: '8px', marginBottom: '5px' }}><b>{nombreExportador}</b></p>
            <p style={{ padding: '8px' }}>Planta: <b>{planta}</b></p>
          </Col>
          <Col md={5} style={{ paddingLeft: 0 }}>
            <CerealVariedadDropdown
              cerealInicial={cereal || null}
              required
              textLabel='Producto *'
              textPlaceHolder='Seleccione un producto'
            />
          </Col>
          <Col md={4}>
            <Field
              name='netoOrigen'
              label='Peso neto origen *'
              type='text'
              maxLength={5}
              component={renderTextField}
              placeholder='30000'
            />
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <EntityAutocomplete
              name='chofer'
              label='Chofer'
              entity='chofer'
              placeholder='Chofer - 19999999991'
            />
          </Col>
          <Col md={3}>
            <Field
              name='camion'
              label='Patente camión'
              type='text'
              component={renderTextField}
              upperCase
              placeholder='AA123AA'
            />
          </Col>
          <Col md={3}>
            <Field
              name='acoplado'
              label='Patente acoplado'
              type='text'
              upperCase
              component={renderTextField}
              placeholder='AA123AA'
            />
          </Col>
          <Col md={3}>
            <Field
              name='brutoOrigen'
              label='Peso bruto origen'
              type='text'
              maxLength={5}
              component={renderTextField}
              placeholder='45000'
            />
          </Col>

          <Col md={12} style={{ textAlign: 'right', marginTop: '8px' }}>
            <p>(*) Campo requerido obligatorio</p>
          </Col>
        </Row>
      </div>
      <div className='btn-remito'>
        <Button
          size='sm'
          type='submit'
          style={{ backgroundColor: COLORES.grey.medium, color: 'white', width: '100%' }}
          variant='dark'
          onClick={handleSubmit}
        >
          Siguiente
        </Button>
      </div>
    </form>
  )
}

export default CamposCargaConRemito
